import './Link.scss';
import Component from './Link.js';
export default Component;
